import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Russian } from "flatpickr/dist/l10n/ru.js"

export default class extends Controller {
  connect() {
    const isRussian = document.documentElement.lang === "ru"

    this.picker = flatpickr(this.element, {
      allowInput: false,
      altInputClass: this.element.className,
      altFormat: isRussian ? "d.m.Y H:i" : "M j, Y H:i",
      altInput: true,
      clickOpens: true,
      dateFormat: "Y-m-d H:i",
      disableMobile: true,
      enableTime: true,
      locale: isRussian ? Russian : undefined,
      minuteIncrement: 5,
      onClose: () => this.hideBackdrop(),
      onOpen: (_selectedDates, _dateStr, instance) => this.showBackdrop(instance, isRussian),
      onReady: (_selectedDates, _dateStr, instance) => this.addCloseButton(instance, isRussian),
      position: "auto center",
      time_24hr: true
    })
  }

  disconnect() {
    this.hideBackdrop()
    this.picker?.destroy()
  }

  showBackdrop(instance, isRussian) {
    this.hideBackdrop()

    this.backdrop = document.createElement("button")
    this.backdrop.type = "button"
    this.backdrop.className = "flatpickr-backdrop"
    this.backdrop.setAttribute("aria-label", isRussian ? "Закрыть календарь" : "Close calendar")
    this.backdrop.addEventListener("click", () => instance.close())

    document.body.append(this.backdrop)
  }

  hideBackdrop() {
    this.backdrop?.remove()
    this.backdrop = null
  }

  addCloseButton(instance, isRussian) {
    if (instance.calendarContainer.querySelector("[data-flatpickr-close]")) return

    const actions = document.createElement("div")
    actions.className = "flatpickr-actions"

    const button = document.createElement("button")
    button.type = "button"
    button.dataset.flatpickrClose = "true"
    button.className = "flatpickr-close-button"
    button.textContent = isRussian ? "Готово" : "Done"
    button.addEventListener("click", () => instance.close())

    actions.append(button)
    instance.calendarContainer.append(actions)
  }
}
